<template>
  <main class="honor" id="topDom">
    <section class="honor-section">
      <!-- <img class="img-fluid" src="../assets/imgs/honor.png" alt="#"> -->
      <ul class="breadcrumb">
        <li class="breadcrumb__li --current">
          <router-link to="/" class="breadcrumb__link">{{ $t("i18n.home") }}</router-link>
        </li>
        <li class="breadcrumb__li">
          <span class="breadcrumb__text"> {{ $t("i18n.downloadPage.name") }}</span>
        </li>
      </ul>
      <div class="honor-subtext">
        <p class="honor-subtext-title">{{ $t("i18n.downloadPage.name") }}</p>
        <p class="honor-subtext-title-span">{{ $t("i18n.downloadPage.brief") }}</p>
      </div>
    </section>
    <section>
      <div class="download-navs">
        <ul class="nav nav-tabs">
          <li
            class="nav-item"
            v-for="(item, index) in $t('i18n.downloadPage.titleList')"
            :key="index"
          >
            <span
              class="nav-link"
              :class="{ active: item.index === activeIndex }"
              @click="change(item.index)"
              >{{ item.name }}</span
            >
          </li>
        </ul>
      </div>
    </section>
    <section>
      <div class="container-fluid">
        <div class="download-content">
          <div class="summary-table --mobile-full-width">
            <div class="summary-table__wrapper" v-for="(item, index) in lists">
              <a target="_blank" class="download-link --small  --thumb ">
                <div class="download-link__content mr-2">
                  <h4 class="download-link__title">
                    {{ $i18n.locale == 'zh' ? item.title : item.title_en  }}
                  </h4>
                </div>
                <div class="ml-auto" style="display: flex">
                  <span class="badge mr-0p5 mr-md-1" v-hover="{ className: '--upper' }">{{ item.size + "MB" }}</span>
                  <span class="badge mr-0p5 mr-md-1" v-hover="{ className: '--upper' }">{{ item.extension }}</span>
                  <span class="download-link__download" @click="download(item)"> {{ $t('i18n.download') }}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { getDownList, downloadFile } from "../api/api";
import {Message} from "element-ui";

export default {
  data() {
    return {
      form: {},
      activeIndex: 1,
      lists: [],
    };
  },
  created() {
    this.search();
  },
  mounted () {
    this.goTop();
  },
  methods: {
    change(index) {
      this.activeIndex = index;
      this.search();
    },
    search() {
      getDownList({
        type: this.activeIndex
      }).then(res => {
        if (res.data && res.data.data) {
          this.lists = res.data.data;
        }
      })
    },
    download(item) {
      downloadFile({ id: item.id }, localStorage.getItem('token')).then(res => {
        if (res.data && res.data.code == '1') {
          // window.open("http://a34.madpay.com/" + res.data.data)
          window.open("https://www.jiashengvac.com/" + res.data.data)
          // window.open("http://admin.jiashengvac.com/" + res.data.data)
        } else if (res.data && res.data.code == '0') {
          Message({
            message: "暂无下载文件",
            // message: error.message,
            type: 'error',
            duration: 3 * 1000
          });

        } else {
          Message({
            message: res.data.msg,
            // message: error.message,
            type: 'error',
            duration: 3 * 1000
          });
          if (res.data.msg === "请重新登录") {
            this.$router.push("login")
          }
        }
      })
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // document.querySelector('#topDom').scrollIntoView({
      //   behavior: 'smooth'
      // })
    }
  },
};
</script>

<style scoped>
.honor-section {
  position: relative;
  height: 60rem;
  background-color: #f7f7f7;
}

.honor-subtext {
  position: absolute;
  height: 50%;
  width: 60%;
  left: 13%;
  top: 30%;
  color: #231815;
  font-size: 2.8rem;
  line-height: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.honor-subtext-title {
  font-size: 4rem;
  font-weight: 500;
}

.honor-subtext-title-span {
  font-size: 2.1rem;
  font-weight: 500;
}
.download-navs {
  margin-top: 7.5rem;
}
.nav-tabs {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #231815;
  font-size: 2.1rem;
  font-weight: 500;
}
.nav-tabs .nav-link {
  display: block;
  margin-right: 0.2rem;
  padding: 1rem 1.5rem;
  border: 1px solid transparent;
  cursor: pointer;
  margin-bottom: -1px;
}
.nav-tabs .nav-link.active {
  color: #7e318e;
  background-color: #fff;
  border-color: #d2d0cf;
  border-bottom-color: transparent;
}

.download-contant {
  padding: 5rem 0;
  /* height: 70rem; */
}

.download-contant-item {
  height: 8.5rem;
  border-bottom: 1px solid #c8c9c9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 2rem;
  color: #231815;
}
.download-contant-item .item-left {
  display: flex;
  align-items: center;
}
.download-contant-item .round {
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
  border: 0.1rem solid #7e318e;
  margin-right: 2rem;
}
.download-contant-item .item-right {
  display: flex;
  align-items: center;
}

.download-contant-item .item-right .type {
  width: 6.3rem;
  height: 3.6rem;
  border-radius: 1.4rem;
  border: 1px solid #ccc9c7;
  font-size: 1.5rem;
  line-height: 3.6rem;
  text-align: center;
  margin-right: 1.5rem;
}

.download-contant-item .item-right .operation {
  color: #7e318e;
  margin-left: 2rem;
  width: 8rem;
  cursor: pointer;
  position: relative;
}
.download-contant-item .item-right .operation::after {
  content: ">";
  font-size: 3rem;
  position: absolute;
  right: 10%;
  top: -20%;
  color: #7e318e;
  transform: rotate(90deg);
}
.breadcrumb {
  display: flex;
  height: 8rem;
  align-items: center;
  position: absolute;
  z-index: 80;
  left: 5rem;
  margin: 0;
  padding: 0;
}
.breadcrumb__li {
  position: relative;
  padding-right: 2.5rem;
  margin-right: 2rem;
}
.breadcrumb__link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #999999;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.breadcrumb__li.--current:after {
  content: "";
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.3rem;
  background: url(../assets/imgs/arrow-breadcrumb.svg) no-repeat 50%;
}
.breadcrumb__li:last-child {
  padding-right: 0;
  margin-right: 0;
}
.breadcrumb__text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: black;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.summary-table {
  width: 100%;
  padding: 5rem;
}

.summary-table {
  width: 100%;
  padding: 5rem;
  border: 0.1rem solid #e6e6e6;
  border-radius: 0.4rem;
}
.download-link.--small {
  height: 6rem;
}
.download-link {
  display: flex;
  width: 100%;
  align-items: center;
  min-height: 8rem;
  padding: 1rem 2rem 1rem 5rem;
  position: relative;
  cursor: pointer;
  border-bottom: 0.1rem solid #ededed;
  transition: all .2s ease-in-out;
}

.download-content {
  margin: 3rem 0;
}

.download-link__content {
  display: flex;
  align-items: center;
}
.download-link__title {
  font-size: 1.6rem;
  font-weight: 500;
  color: #000;
  display: block;
  letter-spacing: -.018rem;
  line-height: 3rem;
  margin: 0;
}
.badge.--upper {
  text-transform: uppercase;
}
.badge {
  border: .1rem solid #e6e6e6;
  height: 3rem;
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-weight: 500;
  font-size: 1.1rem;
  color: #4c4c4c;
  letter-spacing: .03rem;
  padding: 0 1.5rem;
  cursor: pointer;
  border-radius: 2rem;
}
.download-link__download {
  font-size: 1.6rem;
  font-weight: 500;
  color: #800080;
  letter-spacing: -.018rem;
  line-height: 3rem;
  padding-right: 2rem;
  position: relative;
}

.badge.--upper {
  text-transform: uppercase;
}

.download-link__title:before {
  content: "";
  position: absolute;
  z-index: 2;
  left: 2rem;
  width: 1rem;
  height: 1rem;
  background: transparent;
  border: .2rem solid #6C2188;
  box-sizing: border-box;
  border-radius: .5rem;
  margin-top: 1rem;
}

@media (max-width: 1023.9px) {

  .download-link__title:before {
    left: 0;
  }
  .honor-subtext {
    font-size: 2rem;
    top: 15%;
  }

  .honor-subtext-title {
    font-size: 4rem;
    font-weight: 500;
  }
  .nav-tabs {
    font-size: 1rem;
  }

    .summary-table {
      padding: 3rem;
      overflow: auto;
      width: calc(100% + 3rem);
      margin-left: -1.5rem;
    }
    .summary-table.--mobile-full-width .summary-table__wrapper {
      min-width: 100%;
      max-width: 100%;
      padding-right: 0;
      margin: 0;
      border-bottom: 0.1rem solid #e6e6e6;
    }
    .download-link.--small {
      height: auto;
      padding: 2rem 1.5rem;
      flex-wrap: wrap;
      width: calc(100% + 3rem);
      margin-left: -1.5rem;
    }
    .download-link__thumb {
      width: 5rem;
      height: 5rem;
      min-width: 5rem;
    }
    .download-link__title {
      line-height: 2.6rem;
      margin-bottom: 1rem;
    }
    .va-btn {
      width: 14rem;
    }
}

@media (max-width: 768px) {
  .honor-subtext-title {
    font-size: 16px;
    font-weight: bold;
    line-height: 1;
  }
  .honor-subtext-title-span {
    font-size: 14px;  
  }
}

</style>



// WEBPACK FOOTER //
// src/view/download.vue